import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputNumber} from "primereact/inputnumber";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {InputSwitch} from "primereact/inputswitch";
import axios from "axios";

const ProfitcenterFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().profitcenterId) || (entity === 'profit-center' && id)) {
      const payload = {
        ...formData,
        ...newFormData
      };
      apiCall('patch', '/api/v2/profit-center/' + (window.App.urlVars().profitcenterId ?? id), payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderProfitcenterList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/profit-center', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderProfitcenterList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/finance/profit-center/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().profitcenterId) || (entity === 'profit-center' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/profit-center/' + (window.App.urlVars().profitcenterId ?? id))
        .then(response => {
          setFormData(response.data.data)
          setNewFormData({})
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"profitcenter-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4"}>
                <Field name="code" render={({meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="code" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIdentifier')}</label>
                    <span className="p-d-block">
                      <InputText
                        id="code"
                        value={formData.code || ''}
                        onChange={(e) => {
                          setFormData({...formData, code: e.target.value});
                          setNewFormData({...newFormData, code: e.target.value});
                        }}
                        className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-8"}>
                <Field name="name" render={({meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="name"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                    <span className="p-d-block">
                      <InputText
                        id="name"
                        value={formData.name || ''}
                        onChange={(e) => {
                          setFormData({...formData, name: e.target.value});
                          setNewFormData({...newFormData, name: e.target.value});
                        }}
                        className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <Field name="margin_policy" render={({meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="margin_policy" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldMarginPolicy')}</label>
                    <span className="p-d-block">
                      <InputNumber
                        id="margin_policy"
                        value={formData.margin_policy ?? null}
                        onValueChange={(e) => {
                          setFormData({...formData, margin_policy: e.value});
                          setNewFormData({...newFormData, margin_policy: e.value});
                        }}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <Field name="active" render={({meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="active" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                    <span className="p-d-block">
                      <div style={{paddingTop: '.25rem'}}>
                        <InputSwitch
                          id="active"
                          checked={!!formData.active}
                          onChange={(e) => {
                            setFormData({...formData, active: e.value});
                            setNewFormData({...newFormData, active: e.value});
                          }}
                        />
                      </div>
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'profit-center' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(ProfitcenterFormComponent);
